const SignInImage = () => {
  return (
    <div
      className="signInImage"
      style={{
        background: `url(${process.env.REACT_APP_CDN_URL}/globalAssets/credippleRippleBackground.png) lightgray 50% / cover no-repeat`,
      }}
    >
      <img
        src={`${process.env.REACT_APP_CDN_URL}/globalAssets/credippleLogoFull.svg`}
        alt="Credipple Logo"
      />
    </div>
  );
};

export default SignInImage;